import { Component } from '@angular/core';
import { PlansComponent } from '../../sections/v2/plansv2/plans.component';
import { ServicesComponent } from '../../sections/v2/servicesSectionv2/services.component';
import { OpinionsComponent } from '../../sections/v2/opinionsV2/opinions.component'; 
import { IndexComponent } from '../../components/index/index.component';
import { InformationComponent } from '../../sections/v2/informationV2/information.component';
@Component({
  selector: 'app-indexPage',
  standalone: true,
  imports: [ IndexComponent,InformationComponent,PlansComponent,OpinionsComponent,ServicesComponent],
  templateUrl: './index.component.html',
  styleUrl: './index.component.scss'
})
export class IndexComponentPagev2 {

}
